var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartboost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4079 5.87456C12.4596 13.4437 6.1704 19.0302 0 20.8963C0 20.8963 9.25129 14.8729 12.5852 4.45909L16.4096 2.00002L17.4079 5.87456Z",
    fill: "url(#paint0_radial_5858_6304)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7041 10.5528C11.692 16.2198 6.07928 20.2931 0.545715 21.9674H22.2669C23.3237 19.1296 23.9003 16.2918 23.9967 13.4523C24.1292 9.5606 19.2875 7.62933 16.7023 10.5528H16.7041Z",
    fill: "url(#paint1_radial_5858_6304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5858_6304",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.540447 21.0711) scale(29.2238 29.0959)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00AC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#40C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#5BCC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#61CF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#73D75F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#91E65F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#BBFA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C5FF5F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5858_6304",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.99838 22.2878) scale(28.2771 28.1534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00AC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#40C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#5BCC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#61CF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#73D75F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#91E65F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#BBFA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C5FF5F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartboost);
export default __webpack_public_path__ + "static/media/chartboost.a02d2ae4db491cc1e0135aede6b22baf.svg";
export { ForwardRef as ReactComponent };